import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-matched-transactions.views.MatchedTransactionList`

export default defineMessages({
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'There are no matched transactions',
  },
  beginMatchingButton: {
    id: `${scope}.beginMatchingButton`,
    defaultMessage: 'Begin matching',
  },
  poTag: {
    id: `${scope}.poTag`,
    defaultMessage: 'PO',
  },
  rfeTag: {
    id: `${scope}.rfeTag`,
    defaultMessage: 'RFE',
  },
  receiptAttachedAriaLabel: {
    id: `${scope}.receiptAttachedAriaLabel`,
    defaultMessage: 'Receipt attached',
  },
  noReceiptAriaLabel: {
    id: `${scope}.noReceiptAriaLabel`,
    defaultMessage: 'No receipt',
  },
  clearedBalanceLabel: {
    id: `${scope}.clearedBalanceLabel`,
    defaultMessage: 'Cleared balance: {amount} {currency}',
  },
})
